export const tipoAtrasoInitialState = {
  tiposAtrasos: [],
  novoTipoAtraso: [],
  tipoAtrasoRemovido: [],
  tipoAtraso: [],
  tipoAtrasoEditado: [],
  dropdownTiposAtrasos: [],
};
